import React from "react";
import type {VoidFunctionComponent} from "react";
import "./ArrangementPreviewButton.scss";
import {useArrangementPreviewButtonLogic} from "./ArrangementPreviewButton.logic";
import {FontIcon} from "../../../../common/FontIcon";

interface IArrangementPreviewButton {
  label: string;
  ariaLabel: string;
  audioUrl: string;
}

export const ArrangementPreviewButton: VoidFunctionComponent<IArrangementPreviewButton> = ({label, ariaLabel, audioUrl}) => {
  const {audioRef, isPreviewPlaying, toggleAudio, resetAudioPreview} = useArrangementPreviewButtonLogic();

  return (
    <>
      <audio className={`previewAudio`} src={audioUrl} ref={audioRef} onEnded={resetAudioPreview} />
      <button className={`arrangementPreviewButton`} aria-label={ariaLabel} title={ariaLabel} onClick={toggleAudio}>
        <FontIcon icon={isPreviewPlaying ? "icon-pause" : "icon-play"} />
        <span className={`buttonLabel`}>{label}</span>
      </button>
    </>
  );
}